import { mediaDataRemote } from './remote/media'
import { userDataRemote } from './remote/user'
import { adminDataRemote } from './remote/admin'
import { UserService } from './service/userService'
import { MediaService } from './service/mediaService'
import { AdminService } from './service/adminService'

const provideAPIService = () => {
  const userService = userDataRemote()
  const mediaService = mediaDataRemote()
  const adminService = adminDataRemote()
  return {
    userService,
    mediaService,
    adminService,
  }
}
export const api = provideAPIService()

export interface APIService {
  userService: UserService
  mediaService: MediaService
}
